// extracted by mini-css-extract-plugin
export default {"logo":"SideBarLogo_logo__SzJSp","logoOO":"SideBarLogo_logoOO__1cUYF","logoDiv":"SideBarLogo_logoDiv__C6xZw","logoName":"SideBarLogo_logoName__Ao6vD"};